import type { FieldConfig } from '@/mocks/questionnaire';
import { inputClass } from '@/pages/home/components/fields/styles';

interface SelectFieldProps {
  field: FieldConfig;
  value: string;
  onChange: (value: string) => void;
}

export default function SelectField({ field, value, onChange }: SelectFieldProps) {
  return (
    <div>
      <label
        htmlFor={field.name}
        className="block text-sm font-semibold text-foreground-900 mb-2"
      >
        {field.label}
        {field.hint ? (
          <span className="text-xs font-normal text-foreground-400 ml-1">{field.hint}</span>
        ) : null}
      </label>
      <div className="relative">
        <select
          id={field.name}
          name={field.name}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className={`${inputClass} appearance-none cursor-pointer pr-10 ${
            value ? 'text-foreground-800' : 'text-foreground-400'
          }`}
        >
          <option value="">请选择</option>
          {(field.options || []).map((option) => (
            <option key={option.value} value={option.label}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center pointer-events-none text-foreground-400">
          <i className="ri-arrow-down-s-line text-base"></i>
        </div>
      </div>
    </div>
  );
}